import styled from 'styled-components';
import { upTo } from 'js/services/MediaQuery';

export const breakpoint = '900px';

export default styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-areas: 'menu panel';
  max-width: 100%;

  ${upTo(breakpoint)`
    grid-template-columns: 1fr;
    grid-template-areas: 'panel';
  `}
`;
